import {apiCall} from "../../../../common/apiActionHandler";
import axios from "axios";

export const createSubscription = (subscription, payment_method, callback) => async (dispatch, getState) => {
    const config = {
        method: 'POST',
        url: '/api/stripe/create_subscription',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {subscription, payment_method}
    }

    apiCall("Creating subscription", config, async config => {
        try {
            const response = await axios.request(config);
            callback(response.data);
        } catch (error) {
            callback(error.response?.data || {errors: ['Unexpected error occurred.']})
        }
    }, dispatch, getState, false);
}

export const cancelSubscription = (subscription, callback) => async (dispatch, getState) => {
    const config = {
        method: 'DELETE',
        url: '/api/stripe/cancel_subscription',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {subscription}
    }

    apiCall("Cancel subscription", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
}

export const updateSubscription = (subscription, callback) => async (dispatch, getState) => {
    const config = {
        method: 'PUT',
        url: '/api/stripe/update_subscription',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {subscription}
    }
    apiCall("Subscription Updated", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data);
    }, dispatch, getState);
}
export const getSubscription = (subscription_id, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_subscription`,
        method: 'GET',
        params: {subscription_id}
    };
    apiCall("Get subscription", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const getPrices = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_prices`,
        method: 'GET'
    };
    apiCall("Get prices", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const getClientPrice = (client_price_id, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_client_price`,
        method: 'GET',
        params: {
            client_price_id: client_price_id
        }
    };
    apiCall("Get client price", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const getProducts = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_products`,
        method: 'GET'
    };
    apiCall("Get products", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const getProduct = (product_id, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_product`,
        method: 'GET',
        params: {product_id}
    };
    apiCall("Get product", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const loadStripeCredentials = (token, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/stripe_credentials`,
        method: 'GET',
        params: {
            token: token
        }
    };
    apiCall("Loading stripe credentials", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const getEmployees = (client_id, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/search/all_employees?disabled=true`,
        method: 'GET'
    };
    apiCall("Get employees", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const getActiveUsersCount = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/count_client_active_users`,
        method: 'GET'
    };
    apiCall("Active users count get successfully", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};
export const getInvoices = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_invoices`,
        method: 'GET'
    };
    apiCall("Get invoices", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const getUpcomingInvoice = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_upcoming_invoice`,
        method: 'GET'
    };
    apiCall("Get upcoming invoice", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const getApiKey = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/stripe/get_stripe_api_key`,
        method: 'GET'
    };
    apiCall("Get api key", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const updatePaymentMethod = (client_id, stripe_payment_method, callback) => (dispatch, getState) => {
    const config = {
        method: 'PUT',
        url: `/api/clients/${client_id}/update_payment_method`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: { stripe_payment_method }
    };

    apiCall("Updating payment method", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};